import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

import { extendedTheme } from './extended-theme';

const customTwMerge = extendTailwindMerge<string, string>({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: Object.keys(extendedTheme.fontSize),
        },
      ],
      'box-shadow': [
        {
          shadow: Object.keys(extendedTheme.boxShadow),
        },
      ],
    },
  },
});
/**
 * A handy utility that makes constructing class names easier.
 * It also merges tailwind classes.
 */
export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}
